import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import { useFormikContext } from "formik";
import { FC } from "react";
import { WizardStepLayout } from '../wizard/wizard-summary-layout';
import Togglebox from "../togglebox/togglebox";
import Label from "../label/label";

interface AutoCreateStepProps {
    onNext: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onBack: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const AutoCreateStep: FC<AutoCreateStepProps> = ({ onNext, onBack }) => {
    const { translate } = useLocale();
    const { setFieldValue, values } = useFormikContext<any>();

    const onAutoCreateFloorGroupChange = () => {
        const newValue = !values.autoCreateFloorGroup;

        if (newValue === false) {
            setFieldValue('autoCreateAccessProfile', false);
        }

        setFieldValue('autoCreateFloorGroup', newValue);
    }

    return <WizardStepLayout onBack={onBack} onNext={onNext}>
        <div className='flex flex-col space-y-1'>
        <span className={`text-portal-blue-primary-shade2 text-xl font-semibold`} >
            {translate.byKey(TranslationKeys.permissions)}
        </span>
        <div className="flex flex-col">
            <Label htmlFor='autoCreateFloorGroup'
                className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.createFloorGroupsPerFloor)}</Label>
            <Togglebox name="autoCreateFloorGroup" label={''} onChanged={onAutoCreateFloorGroupChange} />
        </div>
        <div className="flex flex-col">
            <Label htmlFor='autoCreateFullAccessFloorGroup'
                className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.createFullAccessFloorGroup)}</Label>
            <Togglebox name="autoCreateFullAccessFloorGroup" label={''} />
        </div>
        <div className="flex flex-col">
            <Label htmlFor='autoCreateAccessProfile'
                className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.createFullAccessProfile)}</Label>
            <Togglebox name="autoCreateAccessProfile" label={''} disabled={!values.autoCreateFloorGroup} />
        </div>
        </div>
    </WizardStepLayout>
}

export default AutoCreateStep;